import React from 'react';
import HtmlComponent from 'lib/html-component';

const PrArticles = () =>  {
    const url = '/forum/misc/pr_posts/'

    return (
        <HtmlComponent url={url} />
    )
}

export default (PrArticles);
